import { render, staticRenderFns } from "./choosePlatform.vue?vue&type=template&id=433a02c8"
import script from "./choosePlatform.vue?vue&type=script&lang=js"
export * from "./choosePlatform.vue?vue&type=script&lang=js"
import style0 from "./choosePlatform.vue?vue&type=style&index=0&id=433a02c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports